import type { TOnGoLive } from '~/features/rewind/useRewindCallbacks'

import { PlayerGoLivePopup as PlayerGoLivePopupComponent } from "/app/libraries/arcana/src/blocks/PlayerGoLivePopup/index.ts"

import { useUnit } from 'effector-react'
import { $playerGoLivePopupTranslations } from './translations'

interface PlayerGoLivePopupParams {
  smallPlayer?: boolean
  isFullscreen?: boolean
  onSubmit?: TOnGoLive
  isEvent?: boolean
}

export const PlayerGoLivePopup = ({
  smallPlayer,
  isFullscreen,
  onSubmit,
  isEvent,
}: PlayerGoLivePopupParams) => {
  const { title, go_live_button, go_to_events_button } = useUnit(
    $playerGoLivePopupTranslations
  )

  const buttonTitle = isEvent ? go_to_events_button : go_live_button
  return (
    <PlayerGoLivePopupComponent
      title={title}
      smallPlayer={smallPlayer}
      isFullscreen={isFullscreen}
      buttonTitle={buttonTitle}
      onClick={onSubmit}
    />
  )
}
